import { useCallback, useEffect, useState } from "react";
import Repository from "../../../_base/helper/HttpHelper";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { useForm } from "@mantine/form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Group,
  Image,
  LoadingOverlay,
  Text,
  Title,
  Input,
  Badge,
  Flex,
  Grid,
  ActionIcon,
  Tooltip,
  Pagination,
} from "@mantine/core";
import {
  IconArrowLeft,
  IconEye,
  IconSearch,
  IconTrash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import { EuiImage } from "@elastic/eui";
import { _localization } from "../../../config/location";
import React from "react";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { useDisclosure } from "@mantine/hooks";
import AppAction from "../../../common/AppAction";
import FormChooseItemFrame from "./CollectionProdList/FormChooseItem";
import { getListProductCollection } from "../../../model/CategorySpecial"; // type only (hiện không dùng để fetch)
import DeleteViewFrame from "./CollectionProdList/DeleteView";

export interface ItemModel {
  cssClassStatus: string | null;
  orgId: number | null;
  id: number;
  parentId: number | null;
  barcode: string | null;
  itemCode: string;
  itemName: string;
  itemCost: number;
  inUse: string;
  barcodeUsed: string | null;
  shortName: string;
  primaryImage: string | null;
  discountValue: number;
  warrantyByPartner: string | null;
  warrantyByCus: string | null;
  vat: number | null;
  isPromotional: string | null;
  accessory: string;
  fullModelCode: string;
  profit: number | null;
  categoryId: number | null;
  createdBy: string;
  promotions: string | null;
  lastUpdateDate: string;
  lastUpdatedBy: string;
  lastUpdateLogin: string | null;
  creationDate: string;
  attribute1: string | null;
  attribute2: string | null;
  attribute3: string | null;
  attribute4: string | null;
  attribute5: string | null;
  attribute6: string | null;
  attribute7: string | null;
  attribute8: string | null;
  attribute9: string | null;
  attribute10: string | null;
  attribute11: string | null;
  attribute12: string | null;
  attribute13: string | null;
  attribute14: string | null;
  attribute15: string | null;
  erpInventoryItemId: number | null;
  marketPrice: number;
  unitWeight: number | null;
  weightUomCode: string | null;
  volumeUomCode: string | null;
  unitVolume: number | null;
  primaryUomCode: string | null;
  primaryUnitOfMeasure: string | null;
  dimensionUomCode: string | null;
  unitLength: number | null;
  unitWidth: number | null;
  unitHeight: number | null;
  secondaryUomCode: string | null;
  unitSellingPrice: number;
  longName: string | null;
  warrantyDescrition: string;
  sku: string;
  onhandQuantyty: number | null;
  color: string | null;
  sex: string | null;
  style: string | null;
  purpose: string | null;
  urlCanonical: string | null;
  metaTitle: string | null;
  metaKeyword: string | null;
  metaDescription: string | null;
  tag: string | null;
  description: string | null;
  unitPriceReference: number;
  brandId: number;
  newStatus: string | null;
  hotStatus: string | null;
  bestSaleStatus: string | null;
  saleOffStatus: string | null;
  onlineStatus: string | null;
  orderNumber: number;
  view: number;
  liked: number;
  purchases: number;
  itemSpec: string | null;
  rate: number | null;
  rateCount: number | null;
  url: string;
  itemSummary: string | null;
  videoUrl: string | null;
  hasPrimaryImg: boolean | null;
  hasItemImg: boolean | null;
  hasCustomerImg: boolean | null;
  hasHacomImg: boolean | null;
  hasCategory: boolean | null;
  priceRangeDv: number | null;
  storeAvailables: any[]; // Có thể định nghĩa cụ thể hơn nếu biết cấu trúc
}

export interface Khung {
  id: number;
  tenKhung: string;
  maSanPham: string | null;
  createdDate: string;
  createdBy: number;
  lastUpdatedDate: string;
  lastUpdatedBy: number;
  tblItemModels: ItemModel[];
}
const DetailView = () => {
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state && location.state.id;
  const [loading, setLoading] = useState(false);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  // Danh sách sản phẩm hiện nằm trong form.values.tblItemModels (trả về từ API get-update)
  // productData riêng không cần thiết cho màn hình Khung nên bỏ state cũ tránh nhầm lẫn.
  const form = useForm<Khung>({
    initialValues: {
      id: 0,
      tenKhung: "",
      maSanPham: null,
      createdDate: "",
      createdBy: 0,
      lastUpdatedDate: "",
      lastUpdatedBy: 0,
      tblItemModels: [],
    },
  });

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: "",
    },
  });

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  const callApiGetData = useCallback(async () => {
    if (!id) return;
    try {
      let url = `Skip=${pagination.pageIndex * pagination.pageSize}&Take=${pagination.pageSize
        }`;
      setLoading(true);
      if (formSeachInput.getValues().KeySearch) {
        url += `&KeySearch=${formSeachInput.getValues().KeySearch}`;
      }
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      const callApi = await repository.get(
        `/TblKhung/get-update?id=${id}&${url}`
      );
      if (!isNullOrUndefined(callApi) && !isNullOrUndefined(callApi?.data)) {
        const dataApi = callApi?.data;
        if (dataApi != null && !isNullOrUndefined(dataApi)) {
          const formData: any = {
            ...dataApi,
            Id: dataApi.Id ? dataApi.Id.toString() : null,
          };
          if (!Array.isArray(formData.tblItemModels))
            formData.tblItemModels = [];
          form.setValues(formData);
          setRowCount(dataApi.totalItemCount || 0);
        } else {
          NotificationExtension.Fails("Dữ liệu không tồn tại");
        }
      } else {
        NotificationExtension.Fails("Dữ liệu không tồn tại");
      }
    } catch (e) {
      NotificationExtension.Fails("Lỗi tải dữ liệu");
    } finally {
      setLoading(false);
    }
  }, [id, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    callApiGetData();
  }, [callApiGetData]);

  const products = form.values.tblItemModels || [];

  // Refresh lại dữ liệu khung (wrapper để dùng chung cho modal)
  const fetchDataCollection = useCallback(async () => {
    await callApiGetData();
  }, [callApiGetData]);

  // Hàm bắt buộc truyền vào FormChooseItemFrame (interface yêu cầu) – thực tế logic thêm sản phẩm xử lý trong FormChooseItemFrame.
  // Sau khi thêm phía modal gọi onSearch => fetchDataCollection nên ở đây chỉ để đảm bảo không lỗi.
  const handleChooseItem = useCallback(
    async (_prodId: number) => {
      await fetchDataCollection();
    },
    [fetchDataCollection]
  );

  // local client-side search (simple contains on itemCode & itemName)
  const [search, setSearch] = useState("");
  const filteredProducts = products.filter(
    (p) =>
      !search ||
      p.itemCode?.toLowerCase().includes(search.toLowerCase()) ||
      p.itemName?.toLowerCase().includes(search.toLowerCase())
  );

  const [paginationState, setPaginationState] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });

  // State lưu trữ selection của bảng để xoá nhiều sản phẩm
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const columns = React.useMemo<MRT_ColumnDef<ItemModel>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        size: 100,
        enableSorting: false,
        Cell: ({ row }) => row.index + 1,
      },
      {
        accessorKey: "primaryImage",
        header: "Ảnh sản phẩm",
        Cell: ({ row }) => {
          const imageUrl = row.original.primaryImage;
          return (
            <EuiImage
              size=""
              width={60}
              height={80}
              src={imageUrl || "/default-image.jpg"}
              alt="alt"
            />
          );
        },
      },
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              variant="dot"
              radius="xs"
              // style={{
              //   cursor: "pointer",
              // }}
              size="lg"
            // onClick={() => handleEditData(row.original.id)}
            // onClick={(e: any) => {
            //   editItem(row.original.id, "edit", row.original.itemCode);
            // }}
            >
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "unitSellingPrice",
        header: "Giá bán",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "onhandQuantyty",
        header: "Tồn kho",
        size: 110,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "actions",
        header: "Thao tác",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 100,
        Cell: ({ row }) => {
          const item = row.original;
          const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
          return (
            <Flex direction={"row"} gap={5} align="center">
              <Tooltip label="Xem sản phẩm">
                <ActionIcon variant="light" aria-label="Settings" color="cyan">
                  <Link to={`${hacomUrl}/${item?.url}`} target="_blank">
                    <IconEye size={20} stroke={1.5} />
                  </Link>
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Xóa sản phẩm">
                <ActionIcon
                  variant="light"
                  aria-label="Settings"
                  color="red"
                  onClick={() => deleteItem([item.itemCode])}
                >
                  <IconTrash size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            </Flex>
          );
        },
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data: filteredProducts || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    localization: _localization,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "STT", "itemCode"],
        right: ["status", "actions"],
      },
      //   density: "xs",
    },
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    mantineTableContainerProps: {
      style: { maxHeight: height - 150, minHeight: height - 150 },
    },
    enablePagination: true,
    enableStickyHeader: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    state: {
      rowSelection,
      pagination,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyCellProps: () => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    positionToolbarAlertBanner: "bottom",
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 150 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (100 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  // Xóa sản phẩm trong bộ sưu tập
  const deleteItem = (itemCodes: string[]) => {
    modals.openConfirmModal({
      modalId: "delete",
      title: (
        <>
          <Title order={5}>Xóa sản phẩm trong bộ sưu tập</Title>
        </>
      ),
      children: (
        <DeleteViewFrame
          onSearch={() => fetchDataCollection()}
          itemCode={itemCodes}
          idBST={id}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Chọn sản phẩm vào bộ sưu tập
  const openModal = () =>
    modals.openConfirmModal({
      modalId: "item",
      title: (
        <>
          <div color="white">
            <Title order={5}>Chọn sản phẩm vào khung</Title>
          </div>
        </>
      ),
      children: (
        <FormChooseItemFrame
          onSearch={fetchDataCollection}
          idBST={id}
          onChooseItem={handleChooseItem}
          // Trong tblItemModels id chính là id sản phẩm
          selectedProductIds={products.map((p: any) => p.id)}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  // Mở modal xoá nhiều sản phẩm đã chọn
  const openModalDelete = () => {
    const selectedRows = table.getSelectedRowModel().rows;
    if (!selectedRows || selectedRows.length === 0) {
      NotificationExtension.Fails("Vui lòng chọn sản phẩm cần xoá");
      return;
    }
    const codes = selectedRows
      .map((r) => r.original.itemCode)
      .filter((c): c is string => !!c);
    if (codes.length === 0) {
      NotificationExtension.Fails("Không tìm thấy mã sản phẩm hợp lệ để xoá");
      return;
    }
    deleteItem(codes);
  };

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
        <Flex gap={10} align="center">
          <Button leftSection={<IconArrowLeft />} onClick={handleGoBack}>
            Quay Lại
          </Button>
          <AppAction
            openModal={openModal}
            openModalDelete={openModalDelete}
            openModalCreate={openModal}
          ></AppAction>
        </Flex>
      </Flex>

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  callApiGetData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await callApiGetData();
              }}
            >
              Tìm kiếm
            </Button>{" "}
          </Grid.Col>
        </Grid>
      </Box>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

type FormChooseItemProps = {
  onChooseItem: (prodId: number) => void;
  idBST: number;
  onSearch?: () => void;
  selectedProductIds?: number[];
};

export default DetailView;
